import { JetView } from 'webix-jet';

/**
 * Class representing a view for user profile details options.
 * @extends JetView
 */
export default class detailsPerfilOpcionesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            view: 'toolbar', // Toolbar component
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to the toolbar
                    elements: [
                        { view: 'label', label: _('Detalles'), width: 150 }, // Label for the toolbar
                    ],
                },
            ],
        };
        return {
            width: screen !== 'small' ? 500 : 230, // Conditional width based on screen size
            height: screen !== 'small' ? 300 : 230, // Conditional height based on screen size
            type: 'wide', // Type of layout
            cols: [left], // Columns layout containing the left toolbar
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes
        });
    }
}

// FILE DOCUMENTED
